import React from 'react';
import { Quote } from 'lucide-react';
import { quoteData } from '../data/mock';

const QuoteSection = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-600 via-teal-700 to-emerald-800 relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-full h-full">
          <div className="absolute top-10 left-10 w-32 h-32 border border-white/10 rounded-full" />
          <div className="absolute bottom-10 right-10 w-48 h-48 border border-white/10 rounded-full" />
          <div className="absolute top-1/2 left-1/4 w-24 h-24 border border-white/10 rounded-full" />
        </div>
        <div className="absolute top-0 right-0 w-96 h-96 bg-white/5 rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-emerald-400/10 rounded-full blur-3xl" />
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center">
          {/* Quote Icon */}
          <div className="w-20 h-20 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-8">
            <Quote className="w-10 h-10 text-white" />
          </div>

          {/* Quote Text */}
          <blockquote className="text-2xl sm:text-3xl lg:text-4xl font-light text-white leading-relaxed mb-10 italic">
            "{quoteData.quote}"
          </blockquote>

          {/* Author */}
          <div className="flex flex-col items-center">
            <div className="w-16 h-1 bg-gradient-to-r from-amber-400 to-orange-500 rounded-full mb-6" />
            <p className="text-xl font-bold text-white mb-1">
              {quoteData.author}
            </p>
            <p className="text-teal-200">
              {quoteData.role}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuoteSection;
